import React from 'react';

import ArticleItemContentTitle from '../ArticleItemContentTitle';
import ArticlesItemInfoRow from '../ArticlesItemInfoRow';
import ArticlesItemCommentInfo from '../ArticlesItemCommentInfo';
import ArticlesItemTags from '../ArticlesItemTags/ArticlesItemTags';
import { getDateString } from '../../../sharable/utils/getDateString';
import { useArticlePropsById } from '../../hooks/useArticlePropsById';
import styles from './ArticlesItemContent.module.scss';
import { ArticleItemGroups } from '../ArticleItemGroups/ArticleItemGroups';

interface IArticlesItemContentProps {
  articleId: string;
}

const ArticlesItemContent: React.FC<IArticlesItemContentProps> = ({ articleId }) => {
  const article = useArticlePropsById(articleId);
  const {
    articleTags = [],
    pending: pendingCommentsCount,
    approved: approvedCommentsCount,
    rejected: rejectedCommentsCount,
    all: allCommentsCount,
    publishedAt,
    restrictedWordsGroups
  } = article ?? {};

  return (
    <div className={styles.container}>
      <ArticleItemContentTitle articleId={articleId} />
      <div className={styles.infoItems}>
        <ArticlesItemInfoRow text="Comments:">
          <ArticlesItemCommentInfo commentsName="Pending" commentsCount={pendingCommentsCount} />
          <ArticlesItemCommentInfo commentsName="Approved" commentsCount={approvedCommentsCount} />
          <ArticlesItemCommentInfo commentsName="Rejected" commentsCount={rejectedCommentsCount} />
          <ArticlesItemCommentInfo commentsName="Total" commentsCount={allCommentsCount} />
        </ArticlesItemInfoRow>
        <ArticlesItemInfoRow text="Date:">{getDateString(publishedAt, true)}</ArticlesItemInfoRow>
        <ArticlesItemInfoRow text="Tags:">
          {articleTags?.length ? <ArticlesItemTags tags={articleTags} /> : 'None'}
        </ArticlesItemInfoRow>
        <ArticlesItemInfoRow text="Groups">
          <ArticleItemGroups groups={restrictedWordsGroups} />
        </ArticlesItemInfoRow>
      </div>
    </div>
  );
};

export default ArticlesItemContent;
